import React from "react";
import { ApprovalStatusBadge } from "./approval-status-badge";
import { ApprovalActionsMenu } from "./approval-actions-menu";

export function ApprovalProductCard({
  product,
  onViewProduct,
  onEditProduct,
}) {
  const hasImage = Boolean(product.image);

  return (
    <article className="flex min-w-0 flex-col">
      <div
        role="button"
        tabIndex={0}
        onClick={() => onViewProduct?.(product)}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            onViewProduct?.(product);
          }
        }}
        className={`relative aspect-square h-[140px] cursor-pointer overflow-hidden rounded-xl bg-[#F8F8F8] p-2.5 box-border sm:h-[160px] sm:p-3 ${
          hasImage ? "bg-cover bg-center" : ""
        }`}
        style={
          hasImage ? { backgroundImage: `url(${product.image})` } : undefined
        }
      >
        {hasImage ? (
          <div
            className="pointer-events-none absolute inset-0 bg-gradient-to-b from-black/40 via-black/10 to-transparent"
            aria-hidden
          />
        ) : null}
        <div className="relative z-[1] flex items-start justify-between gap-1">
          <ApprovalStatusBadge status={product.approvalStatus} />
          <div
            className="shrink-0 rounded-full bg-white/90 shadow-sm backdrop-blur-sm"
            onClick={(e) => e.stopPropagation()}
            onKeyDown={(e) => e.stopPropagation()}
          >
            <ApprovalActionsMenu
              product={product}
              onViewProduct={onViewProduct}
              onEditProduct={onEditProduct}
            />
          </div>
        </div>
      </div>
      <div className="mt-2.5 flex flex-col gap-1.5 sm:mt-3 sm:gap-2">
        <div className="flex items-start justify-between gap-1.5">
          <h3 className="my-0 line-clamp-2 text-[13px] font-bold leading-snug text-[#3D3D3D] sm:text-[14px]">
            {product.name}
          </h3>
          <span className="shrink-0 text-[13px] font-bold text-[#111827] sm:text-[14px]">
            {product.price}
          </span>
        </div>
        <span className="flex h-[22px] w-fit max-w-full items-center justify-center truncate rounded-[9px] bg-[#F8F8F8] px-2 text-[11px] font-medium text-[#0088FF] sm:text-[12px]">
          {product.category}
        </span>
      </div>
    </article>
  );
}
